<template>
  <!-- 产品详情 -->
  <div class="all-center-box">

    <div class="header-nav">
      <div class="classifier">
        <span class="line"></span>
        <span style="margin-bottom: 1rem;">相关分类</span>
        <el-tree :default-expand-all="false" style="height: 100%;background-color: transparent; margin-top: 1rem;"
          :data="categoryOptions" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
      </div>
      <div class="w-1500 right-area">
        <div class="address-box w-100 font-bold">
          <a @click="pageJump('/')">首页</a>
          <template v-if="category && category.parent && category.parent.parent">
            /
            <a @click="pageJump('/productType', category.parent.parent)">{{
              category.parent.parent.name
            }}</a></template>
          <template v-for="item in goodsInfo.categoryList">
            /
            <a @click="toProductType(item)">{{ item.name }}</a></template>

          <template v-if="category && category.parent">
            /
            <a @click="
              category.parent.parent
                ? pageJump(
                  '/productType',
                  category.parent,
                  category.parent.parent
                )
                : pageJump('/productType', category.parent)
              ">{{ category.parent.name }}</a></template>
          <template v-if="category">
            /
            <a @click="pageJump('/productTypeScreen', category)">{{
              category.name
            }}</a></template>
          / <a>{{ goodsInfo.name }}</a>
        </div>
        <div class="product-info w-100">
          <div class="pi-right" style="width: 100%">
            <div class="top-box w-100">
              <div class="box-info1 w-100">
                <div class="pull-left">
                  <div class="swiper-container w-100">
                    <div class="swiper-wrapper">
                      <div class="swiper-slide">
                        <img :src="goodsInfo.coverUrl" v-if="goodsInfo.coverUrl" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="pull-right between-top" style="position: relative">
                  <div class="f-l">
                    <div class="box1 w-100" v-if="goodsInfo != ''">
                      {{ goodsInfo.name }}
                    </div>
                    <div class="box2 w-100 filter-condition" style="white-space: nowrap">
                      <span>条件筛选：</span>
                      <div v-for="item in goodsInfo.categoryList" :key="item.id" class="filter-list">
                        <span class="name">{{ item.name }}</span>
                      </div>
                    </div>
                    <!-- <div class="box2 w-100">
                    <span>价格：</span>
                    <p>{{ instsPrice !== '' ? instsPrice : '请先选择型号' }}</p>
                  </div> -->
                    <div class="box2 w-100">
                      <span>所选型号：</span>
                      <p>{{ serialNo !== '' ? serialNo : '请先选择型号' }}</p>
                    </div>
                    <div class="box2 w-100" v-if="goodsInfo != '' && goodsInfo.ext">
                      信息：{{ goodsInfo.ext.seoDesc }}
                    </div>
                    <div class="box2 w-100">
                      <span>参数选型：</span>
                      <div style="display: flex; flex-wrap: wrap" v-if="this.specKeys.length !== 0">
                        <div style="min-width: 35%" v-for="(item, index) in specKeys" :key="item.id">
                          <div class="slelect-list" v-if="item.specValue[0].type === 2">
                            <span class="slelect-name">{{ item.name }}</span>
                            <el-select @change="
                              handleSelectChange(
                                $event,
                                index,
                                selectList[item.id],
                                item.id
                              )
                              " v-model="selectList[item.id]" :placeholder="'请选择' + item.name" filterable clearable>
                              <el-option v-for="ele in item.specValue" :key="ele.id" :label="ele.value"
                                :value="ele.value">
                              </el-option>
                            </el-select>
                          </div>

                          <div class="slelect-list" v-if="item.specValue[0].type === 1">
                            <span class="slelect-name">{{ item.name }}</span>
                            <input style="border: 1px solid #ccc;" clearable placeholder="请输入" v-model="item.value"
                              @keyup.enter="handleInputChange(index)" @blur="handleInputChange(index)"></input>
                            <div style="display: flex; justify-content: center">
                              <div class="box">
                                {{
                                  item.specValue[0].value +
                                  '/' +
                                  item.specValue[0].difference
                                }}
                              </div>
                              <el-tooltip class="item" effect="dark" :content="`步进值${item.specValue[0].difference}`"
                                placement="right">
                                <i class="el-icon-question"></i>
                              </el-tooltip>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else>暂无规格</div>
                    </div>
                    <!-- <div class="box3 w-100">
                    <span>交期：</span
                    ><i>{{
                      goodsInfo.deliveryTime ? goodsInfo.deliveryTime : 2
                    }}</i>
                  </div> -->
                    <div class="box2 w-100">发货仓：东莞/重庆/昆山/厦门/宁波</div>
                    <div class="box2 w-100" v-if="Object.keys(goodsInfo).length < 0">
                      库存：{{ totalInventory
                      }}<span v-if="totalInventory <= 10" style="color: #ff4949; float: unset">(库存不足)</span>
                    </div>
                    <div class="box4 w-100">
                      <span>购买件数：</span>
                      <i @click="amountChange(0)">－</i><input type="number" v-model="amount"
                        @change="amountChange(2)" /><i @click="amountChange(1)">＋</i>
                    </div>
                    <div class="box5 w-100">
                      <span :class="{ active: goodsInfo.isCollect }" @click="isLogin ? collectChange() : login()">{{
                        goodsInfo.isCollect ? '取消' : '' }}收藏</span>
                    </div>
                    <div class="box6 w-100">
                      <a class="active" @click="isLogin ? addCart() : login()">加入购物车</a>
                      <a @click="isLogin ? confirmOrder() : login()">立即购买</a>
                    </div>
                  </div>
                  <div class="f-r" style="position: absolute; right: 0">
                    <a @click="downloadModel" v-loading.fullscreen.lock="fullscreenLoading">3d模型下载</a>
                    <a @click="pdfList.length > 1 ? generateAndDownload() : downloadPDF()"
                      v-loading.fullscreen.lock="fullscreenLoading">PDF下载</a>
                    <a @click="clearAll(1)">参数重置</a>
                  </div>
                </div>
              </div>
              <div class="box-info2 w-100" v-if="specKeys.length > 0">
                <div class="box1 w-100">指定中的规格/尺寸信息</div>
                <div class="box2 w-100">
                  <ul>
                    <li v-for="(item, index) in specKeys" :key="index">
                      <span>{{ item.name }}</span>
                      <p>
                        {{
                          item.specValue && item.specValue.length >= 10
                            ? item.specValue.slice(0, 10)
                            : item.specValue | formatSpecValue
                        }}
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="footer-container w-100">

              <!-- <ul>
                <li @click.stop="pageJump('/productTypeScreen', item)" v-for="item in goodsInfo.categoryList">
                  <a>{{ '·' + item.name }}</a>
                </li>
              </ul> -->
              <div class="lower-box w-100 l-r" style="width: 100%;">
                <div class="box1 w-100">
                  <span @click="tabClick(item)" v-for="item in tabList" :class="{ active: item.key === tabActive }">{{
                    item.label }}</span>
                </div>
                <div @mouseenter="showPdfPage = true" @mouseleave="showPdfPage = false" @mousedown="startDrag"
                  @mouseup="stopDrag" @mousemove="drag" class="box2 w-100"
                  v-if="tabActive === 'information' || tabActive === 'processMethods' || tabActive === 'Tinformation'"
                  style="position: relative; margin-top: 0.5rem; overflow: hidden" :style="{
                    border:
                      imgFileList.length !== 0 ||
                        Object.keys(srcFileInfo).length !== 0
                        ? '1px solid #1947c4'
                        : 'none',
                  }">
                  <div class="zoom-btn-groups" v-if="
                    srcFile.imgFileList !== 0 ||
                    Object.keys(srcFileInfo).length !== 0
                  ">
                    <!-- <el-button class="zoom-btn" @click="zoomIn">
                    <i class="el-icon-zoom-in"></i>
                  </el-button>
                  <el-button
                    :disabled="pdfScale <= 0"
                    class="zoom-btn"
                    @click="zoomOut"
                    icon="el-icon-zoom-out"
                  >
                  </el-button> -->
                  </div>
                  <!-- :style="{
                    left: `${position.left}px`,
                    top: `${position.top}px`,
                  }" -->
                  <div v-if="shouType === 'pdf'" class="pdf-viewer">
                    <div class="pdf-page" v-if="Object.keys(srcFileInfo).length !== 0" v-for="pageNumber in pageList">
                      <PdfViewer ref="PdfViewerRef" :src="srcFileInfo.modelFile
                        ? srcFileInfo.modelFile
                        : srcFileInfo.srcFile
                        " :page="pageNumber" />
                      <!-- @num-pages="handleNumPages" -->
                    </div>
                    <span v-else>暂无数据</span>
                  </div>
                  <div v-if="shouType === 'img'">
                    <!-- <img
                    class="img"
                    ref="pdfViewer"
                    v-if="imgFileList && srcFile.imgFileList !== 0"
                    :src="imgFileList[imgPage].modelFile"
                    :style="{
                      left: `${position.left}px`,
                      top: `${position.top}px`,
                    }"
                  /> -->
                    <div class="pdfViewer" v-if="imgFileList && imgFileList.length !== 0"
                      style="height: 60rem; overflow: auto">
                      <img class="img" v-for="item in imgFileList" :src="item.modelFile"
                        style="width: 100%; height: 100%" />
                      <!-- :style="{
                      left: `${position.left}px`,
                      top: `${position.top}px`,
                    }" -->
                    </div>
                    <span v-else>暂无数据</span>
                  </div>

                  <div class="pdf-btn" v-if="
                    showPdfPage &&
                    shouType === 'pdf' &&
                    Object.keys(srcFileInfo).length !== 0
                  ">
                    <!-- <el-button
                    @click="previousPage"
                    :disabled="page <= 1"
                    type="primary"
                    icon="el-icon-arrow-left"
                    circle
                  ></el-button>
                  <el-button
                    @click="nextPage"
                    :disabled="page >= numPages"
                    type="primary"
                    icon="el-icon-arrow-right"
                    circle
                  ></el-button> -->
                  </div>
                  <div class="pdf-btn" v-if="
                    showPdfPage &&
                    shouType === 'img' &&
                    imgFileList.length !== 0
                  ">
                    <!-- <el-button
                    @click="previousImgPage"
                    :disabled="imgPage <= 0"
                    type="primary"
                    icon="el-icon-arrow-left"
                    circle
                  ></el-button>
                  <el-button
                    @click="nextImgPage"
                    :disabled="imgPage >= imgFileList.length - 1"
                    type="primary"
                    icon="el-icon-arrow-right"
                    circle
                  ></el-button> -->
                  </div>
                </div>
                <div class="box2 w-100" v-else-if="tabActive === '3Dpreview'">
                  <div v-if="preview3d">
                    <a :href="preview3d" target="_blank">
                      <button class="look-btn">查看</button>
                    </a>
                    <iframe :key="iframeKey" :src="preview3d" frameborder="0" height="700px" width="100%"></iframe>
                  </div>
                  <span v-else>暂无数据</span>
                </div>
                <!-- <div class="box2 w-100" v-else-if="tabActive === 'modelVersion'">
                暂无数据
              </div>
              <div class="box2 w-100" v-else>暂无数据</div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getGoodsDetail,
  getCollection,
  goodsCollection,
  addCart,
  submitOrder,
  getGoodsSpecification,
  getThreedModel,
  getGoodsModel,
  getCategories
} from "../../common/http.js";
import { message } from "../../common/common.js";
import PdfViewer from 'vue-pdf';
import JSZip from "jszip";
import CMapReaderFactory from 'vue-pdf/src/CMapReaderFactory.js'
import { saveAs } from "file-saver";
export default {
  name: "productDetails",
  components: { PdfViewer },
  filters: {
    formatSpecValue (value) {
      let str = [];
      for (const p of value) {
        str.push(p.value);
        if (p.checked) {
          str = [];
          str.push(p.value);
          break;
        }
      }
      return str.join("、");
    }
  },
  data () {
    return {
      categoryOptions: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      category: "", // 分类
      goodsInfo: "", // 商品详情
      specInsts: [], // 所有规格
      specKeys: [],
      selectList: {},
      suid: "", // 规格uid
      sname: "", // 规格名称
      inventory: "", // 规格id
      sprice: "", // 规格价格
      progress: 0, // 基础选型进度
      xhShow: true, // 型号展开
      fhShow: true, // 发货展开
      amount: 1, // 数量
      specSelect: [], // 选择的规格
      // isLogin: "",
      isCollect: "",
      logoUrl: "",
      srcFile: "",
      preview3d: undefined,
      tabActive: "information",
      tabList: [
        {
          label: "基本信息",
          key: "information"
        },
        {
          label: "3D预览",
          key: "3Dpreview"
        },
      ],
      iframeKey: 0,
      jsonData: [],
      changeList: [],
      filterCondition: [],
      specId: "", // !下一级规格id
      goodsId: "", // !外层规格key的id
      specValue: "", // !规格名称
      specIndex: 0,
      inputValue: "",
      propertyValue: [],
      serialNo: '',
      instsPrice: "",
      page: 1,
      numPages: 0,
      showPdfPage: false,
      fullscreenLoading: false,
      showImgPage: true,
      imgPage: 0,
      imgFileList: [],
      srcFileInfo: {},
      shouType: 'pdf',
      pdfScale: 1.0,
      goodUid: 0,
      totalInventory: 0,
      isDragging: false,
      startX: 0,
      startY: 0,
      position: {
        left: 0,
        top: 0
      },
      specValues: [],
      specIds: [],
      pageList: 0,
      pdfList: []
    };
  },
  computed: {
    newSelectList () {
      return JSON.parse(JSON.stringify(this.selectList))
    },
    isLogin() {
      if (this.$store.state.userInfo && this.$store.state.userInfo.id) return true
      return false
    }
  },
  mounted () {
    this.getCategoryList()
    if (this.$route.query.obj) {
      this.getGoodsInfo(this.$route.query.obj)
      this.goodUid = this.$route.query.obj
    }
    // this.isLogin = localStorage.getItem("userInfo");
  },
  methods: {
    getCategoryList () {
      getCategories({
        type: 1
      }).then(res => {
        if (res.result) {
          // this.categorys = res.data
          function filterList (list) {
            list.forEach(item => {
              if (item.children) {
                filterList(item.children)
              }

              item.value = item.id,
                item.label = item.name + '(' + item.count + ')',
                item.tree = item.children
            });
            return list
          }
          const options = filterList(res.data)
          this.categoryOptions = JSON.parse(JSON.stringify(options))
        }
      })
    },
    handleNodeClick (data) {
      let that = this
      this.$router.push({
        name: "productTypeScreen",
        path: "/productTypeScreen",
        query: {
          obj: data.id,
          parent: data.name,
          child: data.name,
          childrenName: data.name
        }
      })
    },
    startDrag (e) {
      this.isDragging = true;
      this.startX = e.clientX - this.position.left;
      this.startY = e.clientY - this.position.top;
      document.body.style.cursor = 'grabbing';
    },
    drag (e) {
      if (this.isDragging) {
        this.position.left = e.clientX - this.startX;
        this.position.top = e.clientY - this.startY;
      }
    },
    stopDrag () {
      this.isDragging = false;
      document.body.style.cursor = 'default';
    },
    // 放大
    zoomIn () {
      this.pdfScale += 0.5;
      const element = this.$refs.pdfViewer;
      if (this.shouType === 'pdf') {
        element.$el.style.transform = `scale(${this.pdfScale})`;
      } else {
        element.style.transform = `scale(${this.pdfScale})`;
      }
    },
    zoomOut () {
      this.pdfScale -= 0.5;
      const element = this.$refs.pdfViewer;
      if (this.pdfScale <= 0) {
        return;
      }
      if (this.shouType === 'pdf') {
        element.$el.style.transform = `scale(${this.pdfScale})`;
      } else {
        element.style.transform = `scale(${this.pdfScale})`;
      }
    },
    // pdf翻页相关钩子
    nextPage () {
      if (this.page < this.numPages) {
        this.page += 1;
      }
    },
    previousPage () {
      if (this.page > 1) {
        this.page -= 1;
      }
    },
    nextImgPage () {
      this.imgPage += 1;
    },
    previousImgPage () {
      this.imgPage -= 1;
    },
    onNumPagesChange (page) {
      this.numPages = page;
    },
    handleInputChange (index) {
      // 判断当前规格是否大于当前选的索引
      const inputValue = this.specKeys[index].value;
      if (this.specKeys.length > index + 1) {
        this.specKeys = this.specKeys.slice(0, index + 1);
        this.specIndex = index + 1;
      }
      if (this.specValues.length > index) {
        this.specValues = this.specValues.slice(0, index);
      }
      if (this.specIds.length > index) {
        this.specIds = this.specIds.slice(0, index);
      }
      const value = this.specKeys[index].specValue[0].value;
      const difference = this.specKeys[index].specValue[0].difference;
      const match = value.match(/\d+/g);
      const str = value.match(/[A-Za-z]+/g);
      const num1 = parseInt(match[0]);
      const num2 = parseInt(match[1]);
      if (inputValue === "") {
        return
      }
      if (inputValue < num1 || inputValue > num2) {
        this.$message.error("请输入范围内的值");
        return
      }
      if (inputValue % difference !== 0) {
        this.$message.error("错误的步进值");
        return
      }
      this.inputValue = str ? str[0] + inputValue : inputValue;
      this.propertyValue[index] = this.inputValue;
      const speckeys = this.goodsInfo.specKeys[this.specIndex]
      if (speckeys) {
        this.specId = speckeys.id;
        this.specKeys.push(speckeys);
        this.goodsId = this.specKeys[index].specValue[0].spec_key_id;
        this.specValue = this.inputValue;
        this.specValues.push(this.specValue);
        this.specIds.push(this.goodsId);
        this.getGoodsSpec();
      } else {
        getGoodsModel({ gid: this.goodsInfo.id, propertyValue: this.propertyValue.join("-") }).then(res => {
          if (res.result) {
            this.totalInventory = res.data.inventory;
            this.serialNo = res.data.serialNo;
            this.inventory = res.data.id;
            this.instsPrice = res.data.price;
            this.getThreedModel();
          } else {
            this.$message.error("没有找到相关规格！");
          }
        })
      }
    },
    handleSelectChange (e, index, value, id) {
      // 判断当前规格是否大于当前选的索引
      if (this.specKeys.length > index + 1) {
        this.specKeys = this.specKeys.slice(0, index + 1);
        this.specIndex = index + 1;
      }
      if (this.specValues.length > index) {
        this.specValues = this.specValues.slice(0, index);
      }
      if (this.specIds.length > index) {
        this.specIds = this.specIds.slice(0, index);
      }
      this.propertyValue[index] = value;
      const speckeys = this.goodsInfo.specKeys[this.specIndex];
      if (speckeys) {
        this.specId = speckeys.id;
        this.specKeys.push(speckeys);
        this.goodsId = id;
        this.specValue = value;

        this.specValues.push(this.specValue);
        this.specIds.push(this.goodsId);
        this.getGoodsSpec();
      } else {
        getGoodsModel({ gid: this.goodsInfo.id, propertyValue: this.propertyValue.join("-") }).then(res => {
          if (res.result) {
            this.totalInventory = res.data.inventory;
            this.serialNo = res.data.serialNo;
            this.inventory = res.data.id;
            this.instsPrice = res.data.price;
            this.getThreedModel();
          } else {
            this.$message.error("没有找到相关规格！");
          }
        })
      }
    },
    // ?获取相关规格
    getGoodsSpec () {
      getGoodsSpecification({
        id: this.specIds[0] ? JSON.stringify(this.specIds) : this.goodsId,
        specValue: this.specValues[0] ? JSON.stringify(this.specValues) : this.specValue,
        specId: this.specId
      }).then(res => {
        if (res.result) {
          const newArr = this.specKeys.map(item => {
            if (this.specIndex >= 1) {
              if (this.specId === item.id) {
                item.specValue = res.data;
              }
              return item
            } else {
              return {
                ...item,
                specValue: res.data
              }
            }
          });
          this.specKeys = newArr;
          if (res.data.length === 0) {
            this.$message.error("没有更多了");
            this.specKeys.pop();
            return
          }
          this.specIndex += 1;
        }
      });
    },
    // ?获取3D模型
    getThreedModel () {
      getThreedModel({
        uid: this.$route.query.obj,
        type: 2,
        serialNo: this.serialNo
      }).then(res => {
        if (res.result) {
          this.preview3d = res.data;
          this.iframeKey += 1;
        } else {
          this.preview3d = undefined;
          this.$message.error("没有找到相关模型！");
        }
        // if (res.data.data !== null) {
        //   this.preview3d = res.data;
        // } else {
        //   this.preview3d = res.data.data;
        // }
      });
    },
    generatePDF (fileName, content) {
      const doc = new jsPDF();
      doc.text(content, 10, 10);
      return doc.output("blob");
    },
    async generateAndDownload () {
      console.log('object');
      const zip = new JSZip();
      const downloadPromises = this.pdfList.map(async (item, index) => {
        const pdfBlob = await this.downPDF(item.srcFile);
        zip.file(item.name, pdfBlob);
      });
      await Promise.all(downloadPromises);
      const content = await zip.generateAsync({ type: "blob" });
      saveAs(content, this.goodsInfo.name + ".zip");
    },
    async downPDF (url) {
      const response = await fetch(url);
      if (!response.ok) throw new Error("下载失败");
      return response.blob();
    },
    downloadPDF () {
      if (Object.keys(this.srcFileInfo).length === 0) {
        this.$message.error("当前没有任何PDF资源");
        return
      }
      this.fullscreenLoading = true;
      fetch(this.srcFileInfo.modelFile ? this.srcFileInfo.modelFile : this.srcFileInfo.srcFile).then(response => response.blob()).then(blob => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.srcFileInfo.name);
        link.click();
        // const blob = new Blob([this.srcFileInfo.modelFile], { type: 'text/plain' });
        document.body.appendChild(link);
        window.URL.revokeObjectURL(url)
        setTimeout(() => {
          this.fullscreenLoading = false;
        }, 1000);
      }).catch(() => {
        this.$message.error("下载PDF失败")
        setTimeout(() => {
          this.fullscreenLoading = false;
        }, 1000);
      })
    },
    downloadModel () {
      if (this.serialNo === '') {
        this.$message.error("当前没有任何模型");
        return
      }
      this.fullscreenLoading = true;
      getThreedModel({
        uid: this.$route.query.obj,
        type: 1,
        serialNo: this.serialNo
      }).then(res => {
        if (res.result) {
          fetch(res.data).then(response => response.blob()).then(blob => {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', this.goodsInfo.name + '.STEP');
            link.click();
            // const blob = new Blob([this.srcFileInfo.modelFile], { type: 'text/plain' });
            document.body.appendChild(link);
            window.URL.revokeObjectURL(url)
            setTimeout(() => {
              this.fullscreenLoading = false;
            }, 1000);
          }).catch(() => {
            this.$message.error("下载PDF失败")
            setTimeout(() => {
              this.fullscreenLoading = false;
            }, 1000);
          })
        }
      }).finally(() => {
        setTimeout(() => {
          this.fullscreenLoading = false;
        }, 1000);
      });
    },
    tabClick (item) {
      this.tabActive = item.key;
      // 切换技术图档
      if (item.key === 'processMethods' || item.key === 'Tinformation') {
        this.srcFileInfo = this.pdfList.filter(ele => ele.name.includes(item.label))[0];
      } else if (item.key === 'information') {
        this.srcFileInfo = this.pdfList.filter(item => !item.name.includes("可选加工方式") && !item.name.includes("技术信息"))[0];
      }
      this.showPdfHandel(this.srcFileInfo.modelFile ? this.srcFileInfo.modelFile : this.srcFileInfo.srcFile);
    },
    // 预览PDF
    showPdfHandel (url) {
      const pdfSrc = PdfViewer.createLoadingTask({ url: url, CMapReaderFactory });
      pdfSrc.promise.then((pdf) => {
        this.pageList = pdf.numPages
      })
    },
    // ?获取商品详情
    async getGoodsInfo (guid) {
      const userId = JSON.parse(localStorage.getItem('userInfo'));
      let opt = {
        uid: guid,
        userId: userId ? userId.id : ''
      };
      await getGoodsDetail(opt).then(res => {
        if (res.result) {
          this.goodsInfo = res.data;
          this.totalInventory = res.data.totalInventory;
          this.specKeys = res.data.specKeys.slice(0, 1);
          this.goodsId = this.specKeys[0].id;
          this.serialNo = res.data.modelNumber;
          this.getThreedModel();
          this.getGoodsSpec();
          this.pdfList = [];
          if (this.goodsInfo.productResources.length > 0) {
            this.goodsInfo.productResources.forEach(item => {
              if (item.type === 1) {
                this.pdfList.push(item)
                // const srcFile = item.srcFile.replace(/(\?.*)|(#[\s\S]*)$/, '');
              } else {
                this.imgFileList.push(item);
              }
            });
            if (this.pdfList.length > 1) {
              const pdfInfo = this.pdfList.filter(item => !item.name.includes("可选加工方式") && !item.name.includes("技术信息"))[0];
              const tablist = [
                {
                  label: '可选加工方式',
                  key: 'processMethods'
                },
                {
                  label: "技术信息",
                  key: 'Tinformation'
                }
              ]
              this.tabList.splice(1, 0, ...tablist)
              this.srcFileInfo = pdfInfo;
              this.showPdfHandel(pdfInfo.modelFile ? pdfInfo.modelFile : pdfInfo.srcFile);
            } else {
              this.srcFileInfo = this.pdfList[0];
              this.showPdfHandel(this.pdfList[0].modelFile ? this.pdfList[0].modelFile : this.pdfList[0].srcFile);
            }
            if (this.pdfList.length === 0) {
              this.shouType = 'img';
            }
          }

        }
      });
      if (this.isLogin) {
        return
        getCollection({
          "goods.id": this.goodsInfo.id,
          type: 1,
          kind: 1,
          "user.id": JSON.parse(localStorage.getItem("userInfo")).id
        }).then(res => {
          if (res.result) {
            this.isCollect = res.data.rCount > 0;
          }
        });
      }
      // this.detailsSwiper();
    },
    login () {
      $(".login-eject").fadeIn();
    },
    detailsSwiper () {
      let swiper = new Swiper(
        ".product-info .pi-right .top-box .box-info1 .pull-left .swiper-container",
        {
          loop: true,
          speed: 1000,
          autoplay: {
            delay: 4000,
            disableOnInteraction: false
          }
        }
      );
    },
    // 清空所有
    clearAll (type) {
      this.specKeys = this.goodsInfo.specKeys.slice(0, 1);
      this.goodsId = this.specKeys[0].id;
      // this.serialNo = "";
      this.specId = "";
      this.specValue = "";
      this.specIndex = 0;
      this.inputValue = "";
      this.propertyValue = [];
      this.selectList = {};
      this.getGoodsSpec();
    },
    pageJump (url, data, parent) {
      let params = {};
      if (data) {
        params.obj = encodeURIComponent(
          JSON.stringify({
            id: data.id,
            name: data.name
          })
        );
      }
      if (parent) {
        params.parent = encodeURIComponent(
          JSON.stringify({
            id: parent.id,
            name: parent.name
          })
        );
      }
      if (url == "/productTypeScreen") {
        params.obj = data.id;
      }
      this.$router.push({
        path: url,
        query: params
      });
    },
    toProductType (item) {
      let params = {}
      if (item.parent) {
        // params = {
        //   uid: item.parent,
        //   id: item.id,
        //   name: item.name
        // }
        // this.$router.push({
        //   path: '/productType',
        //   query: params
        // })
      } else {
        params.obj = item.id;
        // params.parent = this.goodsInfo.categoryList[0].name;
        // params.child = this.goodsInfo.categoryList[1].name;
        params.childrenName = item.name;
        this.$router.push({
          path: '/productTypeScreen',
          query: params
        })
      }
    },
    // 数量改变
    amountChange (type) {
      // 如果是减数量
      if (type == 0) {
        if (this.amount > 1) {
          this.amount--;
        }
        return;
      }
      // 如果是加数量
      if (type == 1) {
        if (this.amount < 99) {
          this.amount++;
        }
        return;
      }
      if (type == 2) {
        if (this.amount <= 0) {
          this.amount = 1;
        }
        if (this.amount > 99) {
          this.amount = 99;
        }
      }
    },
    // 收藏商品
    collectChange () {
      const ids = [];
      ids.push(this.goodsInfo.id);
      goodsCollection({
        goodsIds: ids,
        type: this.goodsInfo.isCollect ? 2 : 1
      }).then(res => {
        if (res.result) {
          if (this.goodsInfo.isCollect) {
            message({
              message: "取消收藏成功",
              type: "success"
            });
          } else {
            this.$confirm("收藏成功，是否前往我的收藏?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "success"
            })
              .then(() => {
                this.$router.push("/meCollection");
              })
              .catch(() => { });
          }
          this.goodsInfo.isCollect = !this.goodsInfo.isCollect;
          // this.getGoodsInfo(this.goodUid);
        }
      });
    },
    // 加入购物车
    addCart () {
      if (this.inventory == "") {
        message({
          message: "请先确定型号",
          type: "warning"
        });
        return;
      }
      // if (this.instsPrice === 0) {
      //   message({
      //     message: "当前规格不可加入购物车",
      //     type: "warning"
      //   });
      //   return;
      // }
      addCart({
        quantity: this.amount,
        uid: this.goodsInfo.uid,
        specId: this.inventory,
        type: 1
      }, 'post').then(res => {
        if (res.result) {
          this.$store.commit("refreshCart", true);
          this.$confirm("添加购物车成功，是否前往我的购物车?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "success"
          })
            .then(() => {
              this.$router.push("/meCart");
            })
            .catch(() => { });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 立即购买
    confirmOrder () {
      if (this.inventory == "") {
        message({
          message: "请先确定型号",
          type: "warning"
        });
        return;
      }
      submitOrder({
        quantity: this.amount,
        uid: this.goodsInfo.uid,
        specId: this.inventory,
        type: 1
      }).then(res => {
        if (res.result) {
          // let data = [res.data];
          // let str = JSON.stringify(data);
          this.$confirm("生成意向订单成功，是否前往我的订单?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "success"
          })
            .then(() => {
              this.$router.push("/meOrder");
            })
            .catch(() => { });
        } else {
          this.$message.error(res.msg);
        }
      });
    }
  }
};
</script>
<style type="text/css" scoped="scoped">
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type='number'] {
  -moz-appearance: textfield;
}

.look-btn {
  line-height: 2.25rem;
  width: 7.5rem;
  text-align: center;
  border: 1px solid #feb813;
  margin: 0.3rem 0.875rem 0 0;
  cursor: pointer;
  background: #feb813;
  color: #fff;
}

.filter-condition {
  display: flex;
}

.filter-condition span {
  float: unset !important;
}

.filter-condition .filter-list {
  margin-right: 10px;
}

.filter-condition .filter-list .name {
  color: #124b98;
  margin-left: 15px;
  font-weight: 600;
}

.parameter {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.slelect-list {
  display: flex;
  margin-right: 20px;
  margin-bottom: 15px;
}

::v-deep.slelect-list .el-select .el-input .el-input__inner {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.slelect-name {
  border: 1px solid #ccc;
  text-align: center;
  line-height: 38px;
  padding: 0 5px;
  white-space: nowrap;
  border-right: 0;
}

.footer-container {
  display: flex;
  margin-top: 1.5rem;
}

.footer-container .classifier {
  width: 15%;
  background-color: #fff;
  margin-right: 2rem;
  padding: 1.5rem;
}

.classifier .line {
  border-left: 5px solid#124b98;
  padding-left: 5px;
  height: 100%;
}

.classifier ul li {
  margin: 5px 0;
}

.classifier ul li a {
  margin: 5px 0;
  cursor: pointer;
}

.footer-container .l-r {
  width: 85%;
  padding: 1.5rem;
  background-color: #fff;
  margin-top: 0;
}

.box {
  height: 100%;
  white-space: nowrap;
  color: #999;
  font-size: 0.875rem;
  padding: 0 0.5rem;
}

.pdf-btn {
  position: absolute;
  left: 0;
  top: 50%;
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.pdfViewer {
  overflow: auto;
  max-height: 60rem;
  position: relative;
  width: 100%;
  height: 60rem;
}

.pdfViewer .img {
  /* position: absolute; */
  cursor: grab;
}

.zoom-btn-groups {
  position: absolute;
  right: 2rem;
  top: 2rem;
  line-height: 2rem;
  height: 2rem;
  z-index: 1000;
  border-radius: 25%;

  width: 5rem;
  display: flex;
  justify-content: space-around;
  z-index: 2100;
}

.zoom-btn {
  width: 1.5rem;
  height: 100%;
  font-size: 1.5rem;
  border: none;
  text-align: center;
  cursor: pointer;
  width: 50%;
  background-color: rgba(0, 0, 0, 0.3);
  color: #fff;
  border-radius: 0;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.zoom-btn:hover {
  background-color: rgba(0, 0, 0, 0.7);
}

.pdf-viewer {
  height: 40rem;
  overflow-y: scroll;
  padding: 10px;
}
.pdf-viewer::-webkit-scrollbar {
  width: 0.25rem;
}

.pdf-page {
  margin-bottom: 20px;
  /* Space between pages */
}

.pdf-page .pdf-container {
  width: 100%;
  /* Adjust to fit the width of the container */
}

.tree-area {
  overflow: auto;
  scrollbar-width: none;
  width: 15%;
}

.el-tree-node__content {
  background-color: #f9dccd !important;
  border-radius: 4px;
}

.header-nav {
  display: flex;
  justify-content: space-between;
  position: relative;
}

.header-nav .classifier {
  height: calc(200vh - 28.5rem);
  overflow: auto;
  padding: 1rem;
  background-color: #fff;
  border: 1px solid #1d66b1;
  margin: 0 1rem;
  margin-top: 1rem;

}

.header-nav .classifier::-webkit-scrollbar {
  width: 0.25rem;
}

.header-nav .classifier::-webkit-scrollbar-track {
  background-color: #f5f5f5;
  border-radius: 10px;
  height: 2rem;
}

.header-nav .classifier::-webkit-scrollbar-thumb {
  background: #1d66b1;
  /* 滑块的颜色 */
  border-radius: 10px;
  height: 2rem;
}
.pdf-viewer::-webkit-scrollbar-track {
  background-color: #f5f5f5;
  border-radius: 10px;
  height: 2rem;
}

.pdf-viewer::-webkit-scrollbar-thumb {
  background: #1d66b1;
  /* 滑块的颜色 */
  border-radius: 10px;
  height: 2rem;
}

.header-nav .right-area {
  width: 80%;
}
</style>



// WEBPACK FOOTER //
// src/pages/product/productDetails.vue